
<template>
    <b-modal :no-close-on-backdrop="true" id="modal-property-tree" modal-class="modal-avenue-of-feedback" title="Search Equipment" hide-footer :centered="true" v-model="open">
        <b-form class="px-4">
            <gofix-form-dropdown 
                :disabled="data.status === 'Cancelled' || disabled" 
                label="Equipment" 
                :clearable="false" 
                :filterable="false" 
                v-model="equipmentModel" 
                :options="equipment" 
                vLabel="tag_name" 
                :class="[{'run-loading small-loading': loading.equipment}]" :multiple="true" 
                @search="searchEquipment">
            </gofix-form-dropdown>
        </b-form>
        <b-button-group class="d-block text-right p-1rem pt-0">
            <gofix-button :disabled="$route.params.id != 0 && Item && (Item.status === 'Cancelled' || disabled)" label="APPLY" @click="applyData" noBorder></gofix-button>
        </b-button-group>
    </b-modal>
</template>
<script>

import { mapGetters } from 'vuex';
import { filters } from '@/_filterVar.js'
export default {
    name: 'modal-equipment',
    components: {},
    props: {
        value:{
            type: Boolean,
            default: false
        },
        data:{
            type: Object,
            default: () => {}
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            open: false,
            selected: null,
            pagesEquipment: {
                isCMS: '1',
                limit: 200,
                page: 1,
                totalPage: 0,
                sortColumn: 'tag_name',
                sortDirection: 'ASC',
                filter: JSON.parse(JSON.stringify(filters['equipment']))
            },
            loading: {
                equipment: false
            },
            equipment:[],
            timer: {
                equipment: null,
            },
            equipmentModel:[],
        }
    },
    watch: {
        value: function (val) {
            if(val){
                this.equipmentModel = this.data.case_detail.equipment;
                this.getEquipment();
            }
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        },
        contract_id: function(val) {
            this.getData();
        }
    },
    computed: {
        ...mapGetters({
            Item: "CaseManagementController/Item",
        }),
    },
    async created() {
        
    },
    methods: {
        applyData() {
            this.$emit('updateData', this.equipmentModel)
            this.open = false;
        },
        async searchEquipment(search, loading) {
            loading(true)
            this.equipment = []
            if (this.timer.equipment) {
                clearTimeout(this.timer.equipment);
                this.timer.equipment = null;
            }
            this.timer.equipment = setTimeout(async () => {
                try {
                    await this.getEquipment(search);
                    await loading(false)
                } catch(e) {
                    loading(false)
                }
            }, 500);
        },
        async getEquipment(search = "") {
            this.pagesEquipment.filter['equipment.is_active'] = {  type: 'boolean', value: true }
            this.pagesEquipment.filter.tag_name.value = search;
            this.pagesEquipment.filter.contract_id.value = null
            if(this.data.contract){
              this.pagesEquipment.filter.contract_id.value = this.data.contract.id
            }

            this.pagesEquipment.filter.location_id.value = null
            if(this.data.case_detail.location && this.data.case_detail.location.id){
                this.pagesEquipment.filter.location_id.value = this.data.case_detail.location.id
            }
            else{
                if(this.data.service_location){
                    this.pagesEquipment.filter.location_id.value = this.data.service_location.id
                }
            }

            this.pagesEquipment.filter.service_category_id.value = null;
            if(this.data.case_detail.service_category && this.data.case_detail.service_category.id) {
                this.pagesEquipment.filter.service_category_id.value = this.data.case_detail.service_category.id
            }
            this.loading.equipment = true;
            await this.$store.dispatch("EquipmentV2Controller/getEquipments", this.pagesEquipment)
            .then(response => {
                this.equipment = response.data.data.items;
                this.loading.equipment = false;
            })
            .catch(err => {
                this.loading.equipment = false
            })
        },
    }
}
</script>